module.exports = __webpack_public_path__ + "static/media/start.b4d7d5a7.jpg";